import React from 'react';

import { InformationContainer as StyledInformationContainer } from './Contact.styled';
import { Text } from 'components/v2/Typography/Text';

type Size = 'sm' | 'md';

type Props = {
  icon: React.ReactNode;
  iconColor?: string;
  href: string;
  linkTextPrefix?: string;
  linkText: string;
  description: string;
  size: Size;
  linkColor?: string;
};

export const InformationContainer: React.FC<Props> = ({
  icon,
  iconColor,
  href,
  linkTextPrefix,
  linkText,
  description,
  size,
  linkColor
}) => {
  return (
    <StyledInformationContainer $iconColor={iconColor} $linkColor={linkColor}>
      {icon}
      <a href={href}>
        {linkTextPrefix ? `${linkTextPrefix} ` : ''}
        <strong>{linkText}</strong>
      </a>
      <Text size={size}>{description}</Text>
    </StyledInformationContainer>
  );
};
